export default __webpack_public_path__ + "static/media/road_safety_training_tile.85fd2f7f.jpg";